




















































import { Component, Prop, Mixins } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AuthModule from '@/store/modules/Auth';
import AnnouncementModule from '@/store/modules/Announcement';
import CurrencyModule from '@/store/modules/Currency';
import GetBalanceModule from '@/store/modules/Profile';
import LanguageButton from '@/components/LanguageButton.vue';
import DocumentButton from '@/components/DocDownload.vue';
import MobileButton from '@/components/MobileButton.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import jwt_decode from 'jwt-decode';
import Vue from 'vue';

@Component({
  components: {
    LanguageButton,
    DocumentButton,
    MobileButton,
  },
})
export default class Nav extends Mixins(ErrorHandleMixin) {
  AuthInstance = getModule(AuthModule, this.$store);

  AnnouncementInstance = getModule(AnnouncementModule, this.$store);

  CurrencyRateInstance = getModule(CurrencyModule, this.$store);

  GetBalanceInstance = getModule(GetBalanceModule, this.$store);

  AnnounceList = [];

  currency = '';

  userCurrency: any = {};

  @Prop() readonly toggleSidebar!: Function;

  async created() {
    const expToken: any = jwt_decode(this.AuthInstance.token);
    this.currency = String(expToken.currency);
    await this.GetBalanceInstance.GetBalance();
    this.getDate();
    const res = await this.AnnouncementInstance.FetchAnnouncement({ type: 'agent' });
    if (res.code) {
      this.checkError(res);
    } else {
      this.AnnounceList = await this.AnnouncementInstance.announcementList
        .filter((item) => item.isActive)
        .map((item) => item.content)
        .join(' | ');
    }
    this.userCurrency = jwt_decode(this.AuthInstance.token);
  }

  async onLogout() {
    await this.AuthInstance.Logout();
    this.$router.push('/login');
  }

  getDate() {
    const refreshToken: any = jwt_decode(Vue.prototype.$session.get('ambgames-user-refresh-token'));
    const expiredToken = refreshToken.exp * 1000;
    const currentTime = new Date().getTime();
    if (currentTime >= expiredToken) {
      this.onLogout();
    } else {
      setTimeout(() => {
        this.getDate();
      }, 60000);
    }
  }
}
